<template>
  <div class id="Details">
    {{this.id}}
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "Details",
  data() {
    return {
      id: this.$route.query.id,
    };
  },
  mounted() {
  },
  methods: {
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
  color: #ffffff;
}
.mint-header {
  background-color: rgba(0, 0, 0, 0) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/qrCode.vue